import { createSelector } from 'reselect';
import * as R from 'ramda';

const getCriteria = id => createSelector(
  R.pathOr(null, ['grid', 'criteria', id]),
  tempFile => tempFile,
);

export default {
  getCriteria,
};



// WEBPACK FOOTER //
// ./src/reducers/grid/selectors.js